import Button from '@mui/material/Button';
import { useIntl } from 'react-intl';
import SendIcon from '@mui/icons-material/Send';
import messages from './messages';
import { useInvitePublisher } from '~/hooks/api/useInvitePublisher';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';

type InviteButtonProps = {
  publisherId: number;
};

export const InviteButton = (props: InviteButtonProps) => {
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const invitePublisherMutation = useInvitePublisher({
    onSuccess: () => {
      showSnackbar({
        message: intl.formatMessage(messages.inviteSuccess),
      });
    },
    onError: () => {
      showSnackbar({
        message: intl.formatMessage(messages.inviteFailure),
      });
    },
  });
  return (
    <Button
      onClick={() => {
        invitePublisherMutation.mutate({ id: props.publisherId });
      }}
      disabled={invitePublisherMutation.isPending}
      startIcon={<SendIcon />}
      data-test="invite-button"
    >
      {intl.formatMessage(messages.inviteUser)}
    </Button>
  );
};

export default InviteButton;
